import { render, staticRenderFns } from "./PessoaInput.vue?vue&type=template&id=a5b15324&"
import script from "./PessoaInput.vue?vue&type=script&lang=js&"
export * from "./PessoaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports